import { render } from "./CapitalModal.vue?vue&type=template&id=2a53161c&scoped=true"
import script from "./CapitalModal.vue?vue&type=script&lang=js"
export * from "./CapitalModal.vue?vue&type=script&lang=js"

import "./CapitalModal.vue?vue&type=style&index=0&id=2a53161c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a53161c"]])

export default __exports__